var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0.5C10.08 0.5 0 10.58 0 23C0 35.42 10.08 45.5 22.5 45.5C34.92 45.5 45 35.42 45 23C45 10.58 34.92 0.5 22.5 0.5ZM22.5 36.5C20.85 36.5 19.5 35.15 19.5 33.5C19.5 31.85 20.85 30.5 22.5 30.5C24.15 30.5 25.5 31.85 25.5 33.5C25.5 35.15 24.15 36.5 22.5 36.5ZM25.935 13.235L24.93 25.265C24.825 26.525 23.775 27.5 22.5 27.5C21.225 27.5 20.175 26.525 20.07 25.265L19.065 13.235C18.9 11.225 20.475 9.5 22.5 9.5C22.9531 9.5 23.4017 9.58924 23.8203 9.76262C24.2388 9.93599 24.6192 10.1901 24.9395 10.5105C25.2599 10.8308 25.514 11.2112 25.6874 11.6297C25.8608 12.0483 25.95 12.4969 25.95 12.95C25.95 13.04 25.95 13.145 25.935 13.235Z",
    fill: "#EC0404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertImage);
export default __webpack_public_path__ + "static/media/alert-image.92725926385e9fdfb5824c504efe940b.svg";
export { ForwardRef as ReactComponent };